/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { StopFragmentDoc } from './ShipmentStopFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ICreateQuickRequestMutationVariables = Types.Exact<{
  input: Types.ICreateQuickRequestInput
}>

export type ICreateQuickRequestMutation = { __typename?: 'Mutation' } & {
  createQuickRequest?: Types.Maybe<
    { __typename?: 'CreateQuickRequestPayload' } & {
      errors: Array<{ __typename?: 'Error' } & Pick<Types.IError, 'key' | 'message'>>
      autoAppointmentSchedule?: Types.Maybe<
        { __typename?: 'AutoAppointmentSchedule' } & Pick<
          Types.IAutoAppointmentSchedule,
          'id' | 'appointmentRequest' | 'source'
        > & {
            shipmentStop: { __typename?: 'ShipmentStop' } & Pick<
              Types.IShipmentStop,
              | 'id'
              | 'arrivedAt'
              | 'billOfLadingReference'
              | 'city'
              | 'commodity'
              | 'dropTrailer'
              | 'ediStatusReasonCode'
              | 'ediAppointmentReasonCode'
              | 'note'
              | 'palletCount'
              | 'poReference'
              | 'stateCode'
              | 'stopSequence'
              | 'stopType'
              | 'specialInstruction'
              | 'weight'
            > & {
                autoAppointmentSchedule?: Types.Maybe<
                  { __typename?: 'AutoAppointmentSchedule' } & Pick<
                    Types.IAutoAppointmentSchedule,
                    'id' | 'appointmentRequest' | 'lastRequestedAt'
                  >
                >
                appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                  Types.IShipmentStopAppointment,
                  | 'id'
                  | 'appointmentReference'
                  | 'appointmentType'
                  | 'confirmationReference'
                  | 'confirmedAt'
                  | 'recommendedStartAt'
                  | 'startAt'
                  | 'startAtHasTime'
                  | 'timezone'
                  | 'timeUpdatedAt'
                  | 'endAt'
                  | 'endAtHasTime'
                  | 'status'
                  | 'isWorkIn'
                > & {
                    confirmedBy?: Types.Maybe<
                      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
                    >
                    timeUpdatedBy?: Types.Maybe<
                      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
                    >
                  }
                genericCommodity?: Types.Maybe<
                  { __typename?: 'Commodity' } & Pick<Types.ICommodity, 'id' | 'description'>
                >
                rescheduleRequest?: Types.Maybe<
                  { __typename?: 'RescheduleRequest' } & Pick<
                    Types.IRescheduleRequest,
                    'id' | 'reasonForRequest' | 'isWorkInRequested' | 'updatedAt'
                  > & { createdBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'> }
                >
                shipment: { __typename?: 'Shipment' } & Pick<
                  Types.IShipment,
                  'id' | 'shipperShipmentReference'
                >
                mergedFacility: { __typename?: 'MergedFacility' } & {
                  facility: { __typename?: 'Facility' } & Pick<
                    Types.IFacility,
                    'id' | 'name' | 'uuid' | 'facilityType'
                  > & {
                      shipperFacilities?: Types.Maybe<
                        Array<
                          { __typename?: 'ShipperFacility' } & Pick<
                            Types.IShipperFacility,
                            'id' | 'uuid'
                          >
                        >
                      >
                      location: { __typename?: 'Location' } & Pick<
                        Types.ILocation,
                        'id' | 'address' | 'addressLine2' | 'stateCode' | 'city' | 'zipcode'
                      >
                      onHoldStops: Array<
                        { __typename?: 'ShipmentStop' } & Pick<
                          Types.IShipmentStop,
                          'id' | 'stopType' | 'stopSequence' | 'city' | 'stateCode' | 'dropTrailer'
                        > & {
                            autoAppointmentSchedule?: Types.Maybe<
                              { __typename?: 'AutoAppointmentSchedule' } & Pick<
                                Types.IAutoAppointmentSchedule,
                                'id' | 'lastRequestedAt'
                              >
                            >
                            appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                              Types.IShipmentStopAppointment,
                              'id' | 'status' | 'startAt' | 'endAt' | 'timeUpdatedAt' | 'timezone'
                            > & {
                                timeUpdatedBy?: Types.Maybe<
                                  { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
                                >
                              }
                            shipment: { __typename?: 'Shipment' } & Pick<
                              Types.IShipment,
                              'id' | 'shipperRateType'
                            > & {
                                shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
                                  Types.IShipperApplication,
                                  'id' | 'name'
                                >
                                characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
                                  Types.IShipmentCharacteristics,
                                  | 'backhaulEligible'
                                  | 'bounceCount'
                                  | 'hasDropTrailerStops'
                                  | 'hazmat'
                                  | 'hot'
                                  | 'mustGo'
                                  | 'rolloverCount'
                                  | 'sameDaySpot'
                                >
                              }
                          }
                      >
                    }
                  metadata?: Types.Maybe<
                    { __typename?: 'RecordMergeFacilityMetadataField' } & {
                      arrivalInstructions: { __typename?: 'RecordMergeStringField' } & Pick<
                        Types.IRecordMergeStringField,
                        'value'
                      >
                      equipments: { __typename?: 'RecordMergeEquipmentsField' } & {
                        value?: Types.Maybe<
                          Array<
                            { __typename?: 'Equipment' } & Pick<
                              Types.IEquipment,
                              'id' | 'key' | 'parentKey'
                            >
                          >
                        >
                      }
                      requirements: { __typename?: 'RecordMergeFacilityRequirements' } & Pick<
                        Types.IRecordMergeFacilityRequirements,
                        'value'
                      >
                      safetyRequirements: { __typename?: 'RecordMergeStringField' } & Pick<
                        Types.IRecordMergeStringField,
                        'value'
                      >
                      services: { __typename?: 'RecordMergeFacilityServices' } & Pick<
                        Types.IRecordMergeFacilityServices,
                        'value'
                      >
                    }
                  >
                  schedule?: Types.Maybe<
                    { __typename?: 'RecordMergeFacilityScheduleField' } & {
                      sop: { __typename?: 'RecordMergeStringField' } & Pick<
                        Types.IRecordMergeStringField,
                        'value'
                      >
                      schedulingNotes: { __typename?: 'RecordMergeStringField' } & Pick<
                        Types.IRecordMergeStringField,
                        'value'
                      >
                      rules: { __typename?: 'RecordMergeFacilityScheduleRulesField' } & {
                        value: Array<
                          { __typename?: 'FacilityScheduleRule' } & Pick<
                            Types.IFacilityScheduleRule,
                            | 'appointmentType'
                            | 'autoScheduling'
                            | 'schedulingMethod'
                            | 'procedureRequirements'
                            | 'workInsAllowed'
                            | 'stopType'
                            | 'unloadType'
                            | 'tmsUrl'
                            | 'tmsNotes'
                          >
                        >
                      }
                    }
                  >
                  hours: { __typename?: 'RecordMergeFacilityScheduleHours' } & {
                    value?: Types.Maybe<
                      Array<
                        { __typename?: 'FacilityScheduleHour' } & Pick<
                          Types.IFacilityScheduleHour,
                          | 'id'
                          | 'day'
                          | 'startTime'
                          | 'closed'
                          | 'endTime'
                          | 'stopType'
                          | 'unloadType'
                        >
                      >
                    >
                  }
                  contacts: Array<
                    { __typename?: 'RecordMergeFacilityContactsField' } & {
                      value?: Types.Maybe<
                        Array<
                          { __typename?: 'FacilityContact' } & Pick<
                            Types.IFacilityContact,
                            'id' | 'name' | 'email' | 'canScheduleFor' | 'contactRoles' | 'note'
                          > & {
                              contactMethods: Array<
                                { __typename?: 'FacilityContactMethod' } & Pick<
                                  Types.IFacilityContactMethod,
                                  'id' | 'contactMethod' | 'value'
                                >
                              >
                            }
                        >
                      >
                    }
                  >
                  note: { __typename?: 'RecordMergeStringField' } & Pick<
                    Types.IRecordMergeStringField,
                    'value'
                  >
                  shipperFacility?: Types.Maybe<
                    { __typename?: 'ShipperFacility' } & Pick<Types.IShipperFacility, 'id' | 'uuid'>
                  >
                }
              }
          }
      >
    }
  >
}

export const CreateQuickRequestDocument = gql`
  mutation CreateQuickRequest($input: CreateQuickRequestInput!) {
    createQuickRequest(input: $input) {
      errors {
        key
        message
      }
      autoAppointmentSchedule {
        id
        appointmentRequest
        source
        shipmentStop {
          ...Stop
        }
      }
    }
  }
  ${StopFragmentDoc}
`
export type ICreateQuickRequestMutationFn = Apollo.MutationFunction<
  ICreateQuickRequestMutation,
  ICreateQuickRequestMutationVariables
>

/**
 * __useCreateQuickRequestMutation__
 *
 * To run a mutation, you first call `useCreateQuickRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuickRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuickRequestMutation, { data, loading, error }] = useCreateQuickRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuickRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateQuickRequestMutation,
    ICreateQuickRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateQuickRequestMutation, ICreateQuickRequestMutationVariables>(
    CreateQuickRequestDocument,
    options
  )
}
export type CreateQuickRequestMutationHookResult = ReturnType<typeof useCreateQuickRequestMutation>
export type CreateQuickRequestMutationResult = Apollo.MutationResult<ICreateQuickRequestMutation>
export type CreateQuickRequestMutationOptions = Apollo.BaseMutationOptions<
  ICreateQuickRequestMutation,
  ICreateQuickRequestMutationVariables
>
